/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoMarketItemTransactionLogListRequest model module.
 * @module model/LogControllerDtoMarketItemTransactionLogListRequest
 * @version 1.0
 */
class LogControllerDtoMarketItemTransactionLogListRequest {
    /**
     * Constructs a new <code>LogControllerDtoMarketItemTransactionLogListRequest</code>.
     * @alias module:model/LogControllerDtoMarketItemTransactionLogListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        LogControllerDtoMarketItemTransactionLogListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>LogControllerDtoMarketItemTransactionLogListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoMarketItemTransactionLogListRequest} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoMarketItemTransactionLogListRequest} The populated <code>LogControllerDtoMarketItemTransactionLogListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoMarketItemTransactionLogListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('buyerAccount')) {
                obj['buyerAccount'] = ApiClient.convertToType(data['buyerAccount'], 'String');
            }
            if (data.hasOwnProperty('sellerAccount')) {
                obj['sellerAccount'] = ApiClient.convertToType(data['sellerAccount'], 'String');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'String');
            }
            if (data.hasOwnProperty('materialType')) {
                obj['materialType'] = ApiClient.convertToType(data['materialType'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoMarketItemTransactionLogListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoMarketItemTransactionLogListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of LogControllerDtoMarketItemTransactionLogListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['buyerAccount'] && !(typeof data['buyerAccount'] === 'string' || data['buyerAccount'] instanceof String)) {
            throw new Error("Expected the field `buyerAccount` to be a primitive type in the JSON string but got " + data['buyerAccount']);
        }
        // ensure the json data is a string
        if (data['sellerAccount'] && !(typeof data['sellerAccount'] === 'string' || data['sellerAccount'] instanceof String)) {
            throw new Error("Expected the field `sellerAccount` to be a primitive type in the JSON string but got " + data['sellerAccount']);
        }
        // ensure the json data is a string
        if (data['level'] && !(typeof data['level'] === 'string' || data['level'] instanceof String)) {
            throw new Error("Expected the field `level` to be a primitive type in the JSON string but got " + data['level']);
        }
        // ensure the json data is a string
        if (data['materialType'] && !(typeof data['materialType'] === 'string' || data['materialType'] instanceof String)) {
            throw new Error("Expected the field `materialType` to be a primitive type in the JSON string but got " + data['materialType']);
        }

        return true;
    }


}

LogControllerDtoMarketItemTransactionLogListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
LogControllerDtoMarketItemTransactionLogListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
LogControllerDtoMarketItemTransactionLogListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
LogControllerDtoMarketItemTransactionLogListRequest.prototype['skip'] = undefined;

/**
 * @member {Date} beginDate
 */
LogControllerDtoMarketItemTransactionLogListRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
LogControllerDtoMarketItemTransactionLogListRequest.prototype['endDate'] = undefined;

/**
 * @member {String} buyerAccount
 */
LogControllerDtoMarketItemTransactionLogListRequest.prototype['buyerAccount'] = undefined;

/**
 * @member {String} sellerAccount
 */
LogControllerDtoMarketItemTransactionLogListRequest.prototype['sellerAccount'] = undefined;

/**
 * @member {String} level
 */
LogControllerDtoMarketItemTransactionLogListRequest.prototype['level'] = undefined;

/**
 * @member {String} materialType
 */
LogControllerDtoMarketItemTransactionLogListRequest.prototype['materialType'] = undefined;






export default LogControllerDtoMarketItemTransactionLogListRequest;

